const ShimmerNewProducts = ({ count = 6 }) => {
  return (
    <section className="mt-10 px-4 sm:px-6 animate-pulse">
      <div className="rounded-2xl bg-slate-900 p-4 text-white">
        
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <div>
            <div className="h-5 w-40 bg-slate-700 rounded mb-2"></div>
            <div className="h-4 w-52 bg-slate-700 rounded"></div>
          </div>
          <div className="h-8 w-24 bg-slate-700 rounded-full"></div>
        </div>

        {/* Horizontal Cards */}
        <div className="flex gap-3 overflow-x-auto pb-2">
          {[...Array(count)].map((_, i) => (
            <div
              key={i}
              className="w-[165px] sm:w-[190px] lg:w-[210px] shrink-0 rounded-xl bg-white/10 p-2"
            >
              {/* Image */}
              <div className="aspect-[3/4] w-full bg-slate-700 rounded-md"></div>

              {/* Text */}
              <div className="mt-2 space-y-2">
                <div className="h-3 w-3/4 bg-slate-700 rounded"></div>
                <div className="h-3 w-1/2 bg-slate-700 rounded"></div>
                <div className="h-3 w-1/3 bg-slate-700 rounded"></div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ShimmerNewProducts;